// extracted by mini-css-extract-plugin
module.exports = {"warning-info-container":"NewAddressEffective_warning-info-container__L-3Av","warning-alert":"NewAddressEffective_warning-alert__NyYDf"};